import { useFastCommentsCount } from '@components/FastCommentWidget';
import { Badge } from '@simplywallst/ui-core';

interface Props {
  canonicalUrl: string;
}

const CommentCount = ({ canonicalUrl }: Props) => {
  const { commentCount } = useFastCommentsCount(canonicalUrl);
  return commentCount > 0 ? <Badge>{commentCount}</Badge> : null;
};

export default CommentCount;
